import React from 'react';

export default function NoInternetContent() {
  return (
    <div className="page-content">
      <div id="main-frame-error" className="interstitial-wrapper">
        <div id="main-content" jstcache="0">
          <div className="icon icon-generic" alt="">
          </div>
          <div id="main-message">
            <h1>
              <span>This site can’t be reached</span>
            </h1>
            <p>
              <strong>asdasd.sd</strong>’s server IP address could not be found.
            </p>
            <div className="error-code">DNS_PROBE_FINISHED_NXDOMAIN</div>
          </div>
        </div>
      </div>
    </div>
  );
}
